var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.8008,
    width: 16.5084,
    height: 13.2067,
    rx: 2,
    fill: "#939CF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50039 11.0379C4.72719 11.0379 4.10039 11.6647 4.10039 12.4379V21.4379C4.10039 22.2111 4.72719 22.8379 5.50039 22.8379H16.5004C17.1968 22.8379 17.7745 22.3293 17.8823 21.6633H19.1184C19.2263 22.3293 19.8039 22.8379 20.5004 22.8379H23.5004C24.2736 22.8379 24.9004 22.2111 24.9004 21.4379V12.4379C24.9004 11.6647 24.2736 11.0379 23.5004 11.0379H20.5004C19.8038 11.0379 19.226 11.5467 19.1184 12.2129H17.8824C17.7748 11.5467 17.197 11.0379 16.5004 11.0379H5.50039ZM16.5004 24.0379C17.3046 24.0379 18.0235 23.6728 18.5004 23.0993C18.9773 23.6728 19.6962 24.0379 20.5004 24.0379H23.5004C24.9363 24.0379 26.1004 22.8738 26.1004 21.4379V12.4379C26.1004 11.002 24.9363 9.83789 23.5004 9.83789H20.5004C19.6962 9.83789 18.9773 10.203 18.5004 10.7765C18.0235 10.203 17.3046 9.83789 16.5004 9.83789H5.50039C4.06445 9.83789 2.90039 11.002 2.90039 12.4379V21.4379C2.90039 22.8738 4.06445 24.0379 5.50039 24.0379H16.5004Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 7.8125H26.3125C27.4171 7.8125 28.3125 8.70793 28.3125 9.8125V19.8125",
    stroke: "black",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.54 12.8008L18.4375 21.001",
    stroke: "black",
    strokeWidth: 1.2,
    strokeDasharray: "2.3 1.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/Coupon.be643dce522a016889b5d9dc1263d275.svg";
export { ForwardRef as ReactComponent };